import React from 'react';

const PackageDetailRightMenu = () => {
  return <></>;
};

export default PackageDetailRightMenu;
